import styled from 'styled-components';
import {
  desktop_breakpoint,
  tablet_breakpoint,
} from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';
import Colors from 'pubweb-smokey/dist/colors';
import chZindex from '../zIndex';

export const StickyNavStyles = styled.div`
  position: sticky;
  top: 0;
  min-height: 50px;
  width: 100%;
  background-color: ${Colors.secondary.navy1.standard};
  color: #fff;
  z-index: ${chZindex.navMenuItemsDesktop};

  > div {
    padding: 10px;
    display: flex;

    > div {
      margin-top: 5px;
    }

    .favoriting-heart-container {
      margin-top: 0px;
    }

    .sticky-description {
      display: none;
    }

    .sticky-links {
      display: none;
    }

    .sticky-buttons {
      display: flex;
      margin-left: auto;
      button {
        margin: -6px 0 0 20px;
        font-size: 10px;
        width: 120px;
      }
    }
  }

  @media only screen and (min-width: ${tablet_breakpoint}px) {
  }

  @media only screen and (min-width: ${desktop_breakpoint}px) {
    min-height: 71px;
    > div {
      padding: 24px 40px;

      div {
        margin-top: 0;
      }

      .sticky-links {
        display: block;
        padding: 0 30px;
        border-left: 2px solid #3e76ac;
        a {
          padding: 0 15px;
          text-transform: uppercase;
          font-family: 'source-sans-pro';
          font-size: 12px;
          line-height: 14px;
          letter-spacing: 1px;
          cursor: pointer;
        }
      }
      .sticky-description {
        display: block;
        padding: 0 30px 0 20px;
      }

      .sticky-buttons {
        button {
          position: relative;
          top: 3px;
          font-size: 13px;
          width: auto;
        }
      }
    }
  }
`;
